import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { AnimatePresence } from 'framer-motion';
import React__default from 'react';
import { useQueryComments } from '../../../../../comments/queries/useQueryComments.js';
import ExpandedFdocCommentsTab from '../../../ExpandedFdoc/ExpandedFdocCommentsTab.js';
import { ExpandedFdocSidebarAddComment } from '../../../ExpandedFdoc/ExpandedFdocSidebar_AddComment.js';

const ExtraPanelTabComments = ({ commentInputVisible, resourceId }) => {
  const [editingComment, setEditingComment] = React__default.useState(null);
  const { comments } = useQueryComments(resourceId);
  const isInputVisible = commentInputVisible || editingComment;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(ExpandedFdocCommentsTab, {
        comments,
        resourceId,
        isFullscreen: false,
        onStartEditingComment: setEditingComment
      }),
      /* @__PURE__ */ jsx(AnimatePresence, {
        children: isInputVisible && /* @__PURE__ */ jsx(ExpandedFdocSidebarAddComment, {
          editingComment,
          onCancelEditingComment: () => {
            setEditingComment(null);
          },
          isFullscreen: false,
          resourceId,
          canAutoFocus: false
        }, "add-comment-input")
      })
    ]
  });
};

export { ExtraPanelTabComments };
//# sourceMappingURL=ExtraPanelTabComments.js.map
